var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".password-reset{overflow-y:auto;background-image:url(" + escape(require("../../../../assets/images/background/login/comp-1.jpg")) + ");background-size:cover}.password-reset h1{font-size:20pt}.password-reset .text{color:#fff}.password-reset .loginbox{background:rgba(184,52,56,.9);margin-bottom:50px;color:#fff;max-width:750px}.password-reset .loginbox .error{color:#ff8a1b}.password-reset .loginbox a{color:#fff;font-style:italic}.password-reset .regbox{font-size:18px;font-weight:600;background-color:#789;opacity:.9;margin-top:200px;max-width:750px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/authentication/component/passwordResetView/passwordResetView.scss
// module id = j2/v
// module chunks = 0